import React, { useCallback } from 'react'
import { DeleteIcon } from '@chakra-ui/icons'
import { useNavigate, useParams } from 'react-router-dom'
import { useToast, Text, Heading, Button, HStack, VStack } from '@chakra-ui/react'

import { Card, Page, PageHeader, FieldList, FieldListItem, ButtonEdit } from 'components'

import { QuestionListGroup, QuestionListGroupItem } from 'modules/questions/components'

import { FormStatus } from '../enums'
import { DimensionDataTabs } from '../containers'
import { useFormDetailQuery, useFormPublishMutation, useFormArchiveMutation } from '../hooks'

export const FormDetailPage = props => {
  const toast = useToast()
  const navigate = useNavigate()
  const { formId } = useParams()
  const [formPublish] = useFormPublishMutation(formId)
  const [formArchive] = useFormArchiveMutation(formId)
  const { data, loading } = useFormDetailQuery(formId)

  const handleBack = useCallback(() => navigate('..'), [navigate])
  const handleEdit = useCallback(() => navigate('editar'), [navigate])

  const handlePublish = useCallback(async () => {
    await formPublish()
    toast({
      status: 'success',
      title: 'Questionário publicado.',
      description: 'O questionário foi publicado com sucesso.'
    })
  }, [toast, formPublish])

  const handleArchive = useCallback(async () => {
    await formArchive()
    toast({
      status: 'success',
      title: 'Questionário arquivado.',
      description: 'O questionário foi arquivado com sucesso.'
    })
  }, [toast, formArchive])

  return (
    <Page>
      <PageHeader heading={`Questionário #${formId}`} onBack={handleBack}>
        <ButtonEdit disabled={data?.status !== FormStatus.PREPARATION} onClick={handleEdit} />
        <Button
          variant='outline'
          colorScheme='red'
          isLoading={loading}
          onClick={handleArchive}
          leftIcon={<DeleteIcon />}>
          Arquivar
        </Button>
      </PageHeader>

      <VStack align='stretch'>
        <HStack align='stretch'>
          <Card flex={1}>
            <FieldList isLoading={loading} isReadOnly={true}>
              <FieldListItem label='Nome'>
                <Text>{data?.name}</Text>
              </FieldListItem>

              <FieldListItem label='Setor'>
                <Text>{data?.sector.name}</Text>
              </FieldListItem>

              <FieldListItem label='Data de inicio'>
                <Text>{data?.beginDate}</Text>
              </FieldListItem>

              <FieldListItem label='Data de fim'>
                <Text>{data?.endDate}</Text>
              </FieldListItem>
            </FieldList>
          </Card>
          <Card minW='250px' justify='space-between'>
            <Heading size='md' textAlign='center'>
              Estado
            </Heading>
            <Text fontSize='md' textAlign='center'>
              {FormStatus.toString(data?.status)}
            </Text>
            {data?.status === FormStatus.PREPARATION && (
              <Button colorScheme='green' isLoading={loading} onClick={handlePublish}>
                Publicar
              </Button>
            )}
            {data?.status === FormStatus.AVAILABLE && (
              <Button colorScheme='red' isLoading={loading} onClick={handleArchive}>
                Arquivar
              </Button>
            )}
          </Card>
        </HStack>
        <Card>
          <DimensionDataTabs>
            {dimension => (
              <QuestionListGroup mb={3} placeholder='Não existem questōes nesta dimensão'>
                {data?.questions.map(
                  (question, index) =>
                    question.dimension.id === dimension.id && (
                      <QuestionListGroupItem key={index} question={question} />
                    )
                )}
              </QuestionListGroup>
            )}
          </DimensionDataTabs>
        </Card>
      </VStack>
    </Page>
  )
}

export default FormDetailPage
